import "../src/authentication/entry";
import "controllers"

require("@rails/ujs").start();
require("@rails/activestorage").start();
require("chart.js");
